export default __webpack_public_path__ + "static/media/footer-chatwithus-icon.36668b27.svg";